import { FC } from 'react';
import styled from 'styled-components';
import { ClassNameProps } from 'components/ozone-component';

interface Props extends ClassNameProps {
  enableSticky?: boolean;
  top?: number;
  layer?: number;
}

const StickyWrapper = styled.div<{ $top?: number; $layer?: number }>`
  position: -webkit-sticky;
  position: sticky;
  top: ${({ $top }) => {
    return $top ?? '0';
  }}px;
  z-index: ${({ $layer }) => {
    return `var(--zindex-layer-0${$layer ?? '0'})`;
  }};
`;

/**
 * @param enableSticky - To enable the sticky effect. true by default
 * @param top - Distance from top
 * @param layer - Z-index layer, check varables.css
 */

export const Sticky: FC<React.PropsWithChildren<Props>> = ({
  enableSticky = true,
  top = 0,
  layer,
  children,
}) => {
  return enableSticky ? (
    <StickyWrapper $top={top} $layer={layer}>
      {children}
    </StickyWrapper>
  ) : (
    <>{children}</>
  );
};
